var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5168 3.4129C7.12969 2.18903 4.78302 2.99851 3.20085 5.29955C4.65011 5.20045 5.80446 5.5402 6.63099 6.36641C3.49829 7.45645 1.84777 9.5979 2.01105 13.0224C3.56791 11.5965 5.35007 10.6854 7.40182 10.3881C6.71959 12.8899 7.02084 15.1073 8.41568 17.0081C9.00045 13.5861 10.2624 11.2889 12.2572 10.2105C14.395 10.5 16.4291 11.9491 18.3568 14.5886C18.6821 12.276 18.3935 10.0934 16.467 8.25306C18.377 7.63919 20.3946 7.65721 22.5223 8.32384C21.1123 5.20817 18.8453 3.68959 15.4177 4.33821L17.9365 1.81196C15.7152 0.442665 13.2799 0.69619 10.5168 3.4129Z",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9836 10.3893C14.8936 14.5043 15.4368 18.9817 14.9192 24.4003C14.8862 24.741 14.6242 25 14.3154 25H11.2954C11.0245 25 10.822 24.7311 10.8663 24.4355C11.5928 19.5265 11.9251 15.273 11.5074 10.6949",
    stroke: "black",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.8132b725.svg";
export { ForwardRef as ReactComponent };